<template>
    <div>
        {{relationLabel}}
    </div>
</template>

<script>

    export default {
        props: ['system'],
        data() {
            return{
                objectType:this.$cache.getDic("role_type"),
            }
        },
        computed:{
            relationLabel(){
                for (let item of this.objectType) {
                    if (item.code == this.system) {
                        return item.name.replace('角色','')
                    }

                }
            }
        }
    }
</script>